<app-header></app-header>
<div *ngIf="card != null" class="content">
  <div class="form-recharge">
    <form [formGroup]="form">
      <div class="main-title dashboard-title"><span>Dane do realizacji płatności</span></div>
      <div class="small75 progress-path">
        Doładowanie istniejącej karty > <b>Płatność</b>
      </div>
      <div class="description">
      <span class="body small75">
          Do wyboru masz następujące możliwości:
          <ul>
              <li>wykonać przelew tradycyjny, na podane niżej konto bankowe,</li>
              <li>zapłacić kartą on-line.</li>
          </ul>
      </span>
      </div>
      <div class="recharge-options">
        <div class="title">
          Dane do płatności przelewem
        </div>
        <br/>
        <label for="seller">nazwa firmy</label>
        <input id="seller" maxLength="150" name="seller" readOnly type="text"
               value="SUPRASAT IGNACY ZABOROWSKI"/><br/>
        <label for="bank">bank</label>
        <input id="bank" maxLength="150" name="bank" readOnly type="text" value="PEKAO O. w Kielcach"/><br/>
        <label for="iban">numer konta</label>
        <input id="iban" maxLength="150" name="iban" readOnly type="text"
               value="87 1240 4416 1111 0010 8638 5753"/><br/>
        <label for="reference">numer referencyjny</label>
        <input id="reference" maxLength="150" name="reference" readOnly type="text" value={{refNumber}}/><br/>

        <p class="small75"
           style='
                     margin-left: 225px;
                     margin-right: 30px;
                     margin-top: 0;
                     font-style: italic;
                     text-align: left;
                 '>
          Procedura doładowania karty SIM zostanie wstrzymana do czasu zaksięgowania płatności.<br/>
          Pamiętaj o podaniu numeru referencyjnego w celu szybszej identyfikacji wpłaty.
        </p>
        <div class="buttons" style='justify-content: space-between'>
          <button (click)="resetToCardData()" type="reset">Wróć</button>
          <button (click)="proceedWithBankTransfer()" type="submit">Zapłacę przelewem</button>
        </div>

        <span hidden="hidden">
        <hr/>

          <div class="title">
            Płatność kartą
          </div>
          <br/>
          <div class="buttons" style="justify-content: space-between">
            <button onClick="resetToCardData()" type="reset">Wróć</button>
            <button onClick="proceedWithCC()" type="button">Płacę kartą</button>
          </div>
        </span>
      </div>
    </form>
    <footer class="content-footer">
      <img alt="logo" src="assets/parp-logo.jpg">
    </footer>
  </div>
</div>
